import { QueryKey } from '@tanstack/react-query';
import { UseDataQueryKey } from '../../../../../hooks/useDataQuery/dataQuery.types';

interface ListKeyParams {
  url: string;
  query: Record<string, unknown>;
  isLocalSource: boolean;
}

export const getAsyncAutocompleteListKey = ({
  url,
  query,
  isLocalSource,
}: ListKeyParams): QueryKey => ['async-autocomplete', isLocalSource ? 'local' : 'http', url, query];

interface ByIdsKeyParams {
  url: string;
  ids: string[];
  idsAlias: string;
}

export const getAsyncAutocompleteByIdsKey = ({
  url,
  ids,
  idsAlias,
}: ByIdsKeyParams): UseDataQueryKey => [
  'async-autocomplete-by-ids',
  url,
  idsAlias,
  [...ids].sort(),
];

export const getAsyncAutocompleteByIdsPagedKey = ({
  url,
  ids,
  idsAlias,
}: ByIdsKeyParams): QueryKey => ['async-autocomplete-by-ids-paged', url, idsAlias, ids];
